// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"240":"63e4496a","793":"5071e23f"}[chunkId] + ".js";
};